import http from '@/utils/http';

/**
 * 获取列表-tr
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/goal/monthly/page',
        method: 'post',
        data
    });
};

/**
 * 导入-tr
 */
export function importApi(data) {
    return http({
        url: '/api-lcrm/goal/monthly/import',
        method: 'post',
        data
    });
};

/**
 * 导出-tr
 */
export function exportApi(data) {
    return http({
        url: '/api-lcrm/goal/monthly/export',
        method: 'post',
        data
    });
};

/**
 * 删除-tr
 */
export function deleteApi(data) {
    return http({
        url: '/api-lcrm/goal/monthly/deleteBatch',
        method: 'post',
        data
    });
};
